// assets/scrolling-text.js
if (!window.ScrollingTextDefined) {
  window.ScrollingTextDefined = true;

  class ScrollingText {
    constructor() {
      this.sections = document.querySelectorAll('.scrolling-text-section');
      this.init();
    }

    init() {
      this.sections.forEach(section => {
        const fontFamily = section.getAttribute('data-font-family');
        if (fontFamily) {
          const content = section.querySelector('.scrolling-text-content');
          if (content) content.style.fontFamily = fontFamily;
        }
        this.observeSpeedChanges(section);
      });
    }

    observeSpeedChanges(section) {
      const observer = new MutationObserver(() => {
        const speed = getComputedStyle(section)
          .getPropertyValue('--animation-speed')
          .trim();
        section.querySelectorAll('.scrolling-text-content').forEach(content => {
          content.style.animationDuration = speed;
        });
      });
      observer.observe(section, { attributes: true, attributeFilter: ['style'] });
    }
  }

  window.ScrollingText = ScrollingText;

  document.addEventListener('DOMContentLoaded', () => new window.ScrollingText());
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => new window.ScrollingText());
  }
} else {
  // セクションリロード時：クラス再宣言せず初期化のみ実行
  if (window.ScrollingText) new window.ScrollingText();
}